module.exports = __webpack_public_path__ + "static/media/fa.7fa2062d.png";